
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'


export default {
components: {
Group,
Cell,
},
data() {
return {
shopNumber: 0,
shopInfoList: [],
systemUserInfo:{}
}
},
created() {
this.initSystemUser()
this.initShopList()
},
methods: {
initShopList() {
let _this = this;
let uri = '/v1/shops';
let params = null;
_this.axios.get(uri, params, {
headers: {}
}).then(function (response) {
if (response.data.code != undefined && response.data.code == 0) {
_this.shopNumber = response.data.data.length
if (_this.shopNumber == 1) {
let shopId = response.data.data[0].id

let path = '/shop/' + shopId
_this.$router.push({path: path});
}
if (_this.shopNumber > 1) {
_this.shopInfoList = response.data.data
}

if (_this.shopNumber == 0) {

_this.$router.replace({
path: '/intercept',
query: {
redirect: _this.$router.currentRoute.fullPath,
msg: '['+ _this.systemUserInfo.mobile +']没有能操作的店铺'
}   //登录成功后跳入浏览的当前页面
});
}


} else {


}
}).catch(function (response) {
console.log(response);

});
},
initSystemUser(){
let _this = this;
let uri = '/system/account/info';
let params = null;
_this.axios.get(uri, params, {
headers: {}
}).then(function (response) {
if (response.data.code != undefined && response.data.code == 0) {
_this.systemUserInfo = response.data.data
} else {


}
}).catch(function (response) {
console.log(response);

});
}
}
}



// WEBPACK FOOTER //
// ./src/components/Index.vue